import React from "react";
import { Box, Divider, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../../../theme";

const ApplicationNotesSkeleton: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Box
			m={2}
			sx={{
				border: `1px solid ${zoullooColors.grey[300]}`,
				borderRadius: 3
			}}
		>
			{/* Header Section Skeleton */}
			<Box
				sx={{
					p: 2,
					backgroundColor: zoullooColors.background.paper,
					borderBottom: `1px solid ${zoullooColors.grey[300]}`,
					borderTopLeftRadius: 13,
					borderTopRightRadius: 13,
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center"
				}}
			>
				<Typography variant="h6">
					{t("freelancerDetails.notes.talentRelationship")}
				</Typography>
				<Skeleton variant="rectangular" width={40} height={40} />
			</Box>

			{/* Notes Content Skeleton */}
			<Box
				sx={{
					backgroundColor: zoullooColors.background.paper,
					p: 2,
					borderBottomLeftRadius: 13,
					borderBottomRightRadius: 13
				}}
			>
				{/* Render multiple note skeletons */}
				{[1, 2, 3].map((item, index) => (
					<Box key={item}>
						{/* Note subject skeleton */}
						<Skeleton variant="text" width={150} height={24} sx={{ mb: 1 }} />

						{/* Date and time skeleton */}
						<Skeleton variant="text" width={200} height={16} sx={{ mb: 0.5 }} />

						{/* Author name skeleton */}
						<Skeleton variant="text" width={120} height={16} sx={{ mb: 1 }} />

						{/* Note content skeleton - multiple lines */}
						<Skeleton variant="text" width="100%" height={16} sx={{ mb: 0.5 }} />
						<Skeleton variant="text" width="85%" height={16} sx={{ mb: 0.5 }} />
						<Skeleton variant="text" width="70%" height={16} sx={{ mb: 2 }} />

						{/* Read more link skeleton */}
						<Skeleton variant="text" width={80} height={14} sx={{ mb: 0.5 }} />

						{/* Divider between notes (except for last item) */}
						{index < 2 && <Divider sx={{ mt: 2, mb: 2 }} />}
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default ApplicationNotesSkeleton;
